export default {
  items: [
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-user',
      badge: {
        variant: '',
        text: ''
      }
    },
    {
      name: 'Gambar',
      url: '/galery',
      icon: 'fa fa-image',
      badge: {
        variant: '',
        text: ''
      }
    },
  /*
    {
      name: 'Video',
      url: '/video',
      icon: 'fa fa-video-camera',
      badge: {
        variant: '',
        text: ''
      }
    },
    */
    {
      name: 'Content',
      url: '/content',
      icon: 'fa fa-list',
      badge: {
        variant: '',
        text: ''
      }
    },
    {
      name: 'Headline',
      url: '/headline',
      icon: 'fa fa-home',
      badge: {
        variant: '',
        text: ''
      }
    },
    /*
    {
      name: 'Company',
      url: '/company',
      icon: 'fa fa-building',
      badge: {
        variant: '',
        text: ''
      }
    }
    */
  ]
}
